<template lang="pug">
  div
    spreadsheet(v-if="!id", :opts='opts', ref="sp", @ready="onDataReady")
    detail(v-else, :opts="opts", :data="data")
</template>

<script>
// Generated by CoffeeScript 2.3.0
import { detail } from '../../spreadsheet'

let m

export default (m = {
  components: { detail },
  props: {
    id: String,
  },
  data: function() {
    return {
      data: null,
      opts: {
        tableName: 'logs_edit',
        displayName: '日志',
        columns: [
          {
            label: 'date',
          },
          {
            label: 'account',
          },
          {
            label: 'tableName',
          },
          {
            label: 'docid',
          },
          {
            label: 'label',
          },
          {
            label: '查看',
            text: '详情',
            type: 'button',
            handler: function(item) {
              return router.push(`/logs/${item._id}/detail`)
            },
          },
        ],
        expandable: true,
        trackable: true,
        defaultItem: {
          permissions: {
            所有人: '读取',
          },
        },
        // importable: true
        editable: false,
        recycle: false,
        maxItem: 100,
        pagination: true,
        $sort: {
          modifiedTimestamp: -1,
        },
      },
    }
  },
  watch: {
    id: function() {
      return this.load()
    },
  },
  methods: {
    load: function() {
      if (this.id) {
        return app.api
          .findOne({
            tableName: 'logs',
            _id: this.id,
          })
          .then(res => {
            let date
            this.data = res
            date = new Date()
            date.setTime(this.data.date * 1000)
            return this.$set(this.data, 'date', date.toLocaleString())
          })
      }
    },
    onDataReady: function() {
      return (this.$refs.sp.data = this.$refs.sp.data.map(row => {
        let date
        date = new Date()
        date.setTime(row.date * 1000)
        row.date = date.toLocaleString()
        return row
      }))
    },
    checkRole: function() {
      let ref
      if (!(app.user.角色 && app.user.角色.includes('管理员'))) {
        return router.push('/')
      }
    },
  },
  created: function() {
    return this.checkRole()
  },
  mounted: function() {
    return setInterval(() => this.$refs.sp.init(), 1000)
  },
})
</script>
